import { render, staticRenderFns } from "./StockviewPricingStats.vue?vue&type=template&id=5fef57bf&"
import script from "./StockviewPricingStats.vue?vue&type=script&lang=js&"
export * from "./StockviewPricingStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports